import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'INSS', path: '/#produtos' },
    { name: 'CLT', path: '/#produtos' },
    { name: 'Portabilidade', path: '/#produtos' },
    { name: 'Veículos', path: '/produtos#veiculos' },
    { name: 'Imóveis', path: '/produtos#imoveis' },
    { name: 'Quem Somos', path: '/quem-somos' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    setIsMobileMenuOpen(false);
    if (location.pathname !== '/') {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/63cf3097778040faac4f034b416b1ba0/5298a1df8d2fede732e5918725441ce1.png"
              alt="Carbone Soluções Financeiras"
              className="h-16 md:h-20 w-auto"
            />
          </Link>

          <div className="hidden lg:flex items-center space-x-6">
            <button
              onClick={() => scrollToSection('inss')}
              className="text-navy-800 hover:text-gold-500 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              INSS
            </button>
            <button
              onClick={() => scrollToSection('clt')}
              className="text-navy-800 hover:text-gold-500 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              CLT
            </button>
            <button
              onClick={() => scrollToSection('portabilidade')}
              className="text-navy-800 hover:text-gold-500 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Portabilidade
            </button>
            <button
              onClick={() => scrollToSection('veiculos')}
              className="text-navy-800 hover:text-gold-500 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Veículos
            </button>
            <button
              onClick={() => scrollToSection('imoveis')}
              className="text-navy-800 hover:text-gold-500 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Imóveis
            </button>
            <Link
              to="/quem-somos"
              className="text-navy-800 hover:text-gold-500 font-medium transition-colors whitespace-nowrap"
            >
              Quem Somos
            </Link>
            <Link
              to="/contato"
              className="text-navy-800 hover:text-gold-500 font-medium transition-colors whitespace-nowrap"
            >
              Contato
            </Link>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://wa.me/5519971344445?text=Olá! Gostaria de falar com um especialista."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#25D366] hover:bg-[#20BD5A] text-white font-semibold px-6 py-3 rounded-full shadow-lg transition-all duration-300 hover:shadow-xl flex items-center gap-2 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span className="hidden sm:inline">Fale com um especialista</span>
            </a>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-navy-800 cursor-pointer"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-100 pt-4">
            <div className="flex flex-col space-y-3">
              <button
                onClick={() => scrollToSection('inss')}
                className="text-navy-800 hover:text-gold-500 font-medium transition-colors cursor-pointer text-left py-2"
              >
                INSS
              </button>
              <button
                onClick={() => scrollToSection('clt')}
                className="text-navy-800 hover:text-gold-500 font-medium transition-colors cursor-pointer text-left py-2"
              >
                CLT
              </button>
              <button
                onClick={() => scrollToSection('portabilidade')}
                className="text-navy-800 hover:text-gold-500 font-medium transition-colors cursor-pointer text-left py-2"
              >
                Portabilidade
              </button>
              <button
                onClick={() => scrollToSection('veiculos')}
                className="text-navy-800 hover:text-gold-500 font-medium transition-colors cursor-pointer text-left py-2"
              >
                Veículos
              </button>
              <button
                onClick={() => scrollToSection('imoveis')}
                className="text-navy-800 hover:text-gold-500 font-medium transition-colors cursor-pointer text-left py-2"
              >
                Imóveis
              </button>
              <Link
                to="/quem-somos"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-navy-800 hover:text-gold-500 font-medium transition-colors text-left py-2"
              >
                Quem Somos
              </Link>
              <Link
                to="/contato"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-navy-800 hover:text-gold-500 font-medium transition-colors text-left py-2"
              >
                Contato
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
